import React from 'react';
import { getCategoryClasses } from '../utils/categoryColors';
import { cn } from '../utils/cn';

interface CategoryBadgeProps {
  category: string | null | undefined;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * Компонент для отображения категории анализа с цветовой кодировкой
 * Автоматически применяет соответствующие цвета для каждой из 13 категорий
 */
const CategoryBadge: React.FC<CategoryBadgeProps> = ({ 
  category, 
  size = 'md', 
  className 
}) => {
  const baseClasses = getCategoryClasses(category);
  
  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1.5 text-sm',
    lg: 'px-4 py-2 text-base'
  };

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border font-medium transition-colors',
        baseClasses,
        sizeClasses[size],
        className
      )}
    >
      {category ? category.charAt(0).toUpperCase() + category.slice(1) : 'Прочее'}
    </span>
  );
};

export default CategoryBadge;
